import { render, staticRenderFns } from "./FeedbackResponse.vue?vue&type=template&id=874ce876&"
import script from "./FeedbackResponse.vue?vue&type=script&lang=ts&"
export * from "./FeedbackResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports